import { Theme } from '@mui/material';

const List = (theme: Theme) => {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          paddingRight: theme.spacing(2),
        },
      },
    },
    MuiListItemButton: {
      defaultProps: {},
      variants: [
        {
          props: { color: 'primary2' },
          style: {
            color: theme.palette.primary2.main,
            '&:hover': {
              backgroundColor: 'transparent',
              color: theme.palette.primary.main,
            },
            '&.Mui-selected': {
              color: theme.palette.primary.main,
              backgroundColor: 'transparent',
              '&:hover': {
                color: theme.palette.primary.main,
              },
            },
          },
        },
      ],
    },
  };
};

export default List;
